import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function ImpressumDetails() {
  return <section data-section-id="233618" id="impressum" className="bg-background text-foreground py-32">
      <div className="container mx-auto px-4 max-w-[800px]">
        <h1 className="font-default text-5xl md:text-6xl text-center mb-16 text-foreground font-bold tracking-tight">
          Impressum
        </h1>

        <div className="flex flex-col gap-12">
          <div className="bg-card/50 backdrop-blur-sm p-8 rounded-lg border border-border shadow-sm"><h2 className="font-default text-sm font-bold tracking-wider uppercase text-secondary mb-4" data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:soqilq" data-ast-start="631" data-ast-end="751">Angaben zum Unternehmen</h2><div className="text-base leading-relaxed text-foreground font-sans" data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:nznzkv" data-ast-start="764" data-ast-end="995"><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6xgxw3" data-ast-start="848" data-ast-end="864">Cup4us OG</p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6xekm7" data-ast-start="879" data-ast-end="908">Klagenfurter Straße 67</p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6wyiz7" data-ast-start="923" data-ast-end="976">9300 St. Veit a. d. Glan&nbsp;<br />Österreich<br /><br />Sitz: St. Veit an der Glan</p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6wyiz7" data-ast-start="923" data-ast-end="976"><br /></p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6wyiz7" data-ast-start="923" data-ast-end="976"><br /></p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6wyiz7" data-ast-start="923" data-ast-end="976"><br /></p><p data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:6wyiz7" data-ast-start="923" data-ast-end="976"><br /></p></div></div>

          <Separator className="bg-border/50" />

          <div>
            <h2 className="font-default text-sm font-bold tracking-wider uppercase text-secondary mb-4">
              Vertreten durch
            </h2>
            <div className="text-base leading-relaxed text-foreground font-sans">
              <p>Vertretungsbefugte Gesellschafter:<div>Karl Scheiber jun.</div><div>Koberer Eventservice GmbH</div></p>
            </div>
          </div>

          <Separator className="bg-border/50" />

          <div>
            <h2 className="font-default text-sm font-bold tracking-wider uppercase text-secondary mb-4">
              Kontakt
            </h2>
            <div className="text-base leading-relaxed text-foreground font-sans">
              <p>Telefon: +43 (0) 660 933 76 67</p>
              <p>E-Mail: office@cup4us.at</p>
            </div>
          </div>

          <Separator className="bg-border/50" />

          <div>
            <h2 className="font-default text-sm font-bold tracking-wider uppercase text-secondary mb-4">
              Umsatzsteuer-ID
            </h2>
            <div className="text-base leading-relaxed text-foreground font-sans">
              <p>Umsatzsteuer-Identifikationsnummer:</p>
              <p>ATU79230226</p>
            </div>
          </div>

          <Separator className="bg-border/50" />

          <div>
            <h2 className="font-default text-sm font-bold tracking-wider uppercase text-secondary mb-4">EMITGLIEDSCHAFT / BERUFSRECHT</h2>
            <div className="text-base leading-relaxed text-foreground font-sans">
              <p><div><br /></div><br /><div data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:53t5vx" data-ast-start="2576" data-ast-end="2593"><br /></div><div data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:53ry4x" data-ast-start="2593" data-ast-end="2610" contenteditable="false" style={{}}><br /></div><div data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:53dbnu" data-ast-start="2610" data-ast-end="2627" contenteditable="false" style={{}}><br /></div><div data-ast-id="f:/src/pages/Imprint/sections/ImpressumDetails.tsx|sig:53cjhf" data-ast-start="2627" data-ast-end="2644" contenteditable="false" style={{}}><br /></div></p>
              <p className="mt-2"><br /></p>
            </div>
          </div>

          <Separator className="bg-border/50" />

          
        </div>
      </div>
    </section>;
}